import { render, staticRenderFns } from "./ArrowUp.vue?vue&type=template&id=6ca21dc7"
import script from "./ArrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports